import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Paths } from "../routes";
import { DownloadIcon, HamburgerIcon, NavLogo, LogoStar } from "../assets";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Getebook from "./dialogs/GeteBook";
import { navItem } from "../helpers/common";

const Navbar = () => {
  const navigate = useNavigate();
  const [eBookOpen, setEBookOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div
      className={`${
        currentPath === Paths.Contact ? "md:pt-[73px] pt-[36px]" : "md:pt-[36px] pt-0"
      } w-full lg:max-w-[976px] md:max-w-[768px] sm:max-w-[640px] max-w-full md:px-0 px-4 mx-auto`}
    >
      <Getebook open={eBookOpen} setOpen={setEBookOpen} />
      {isSidebarOpen && (
        <Drawer
          anchor="left"
          open={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          classes={{
            paper: "p-4",
          }}
        >
          <Box
            sx={{ width: 250 }}
            role="presentation"
            onKeyDown={() => setIsSidebarOpen(false)}
            className="h-full"
          >
            <div className="flex items-center">
              <img src={LogoStar} alt="logo-image" />
              <h5 className="m-0 flex items-center text-[#121212] font-semibold md:text-2xl text-xl md:leading-8 leading-6 tracking-[0.48px] cursor-pointer md:pr-6 pr-0">
                incognetoLabs
              </h5>
              {/* <div
                className="w-6 h-6 flex justify-center items-center cursor-pointer"
                onClick={() => setIsSidebarOpen(false)}
              >
                <img src={CrossIcon} alt="close-icon" />
              </div> */}
            </div>
            <List className="!p-0 h-full flex flex-col gap-3 !mt-5">
              {navItem.map((item, index) => (
                <ListItem
                  key={index}
                  disablePadding
                  onClick={() => {
                    item.path && navigate(item.path);
                  }}
                  className="!cursor-pointer"
                >
                  <ListItemButton className="!p-0">
                    <ListItemText
                      primary={item.menuItem}
                      classes={{
                        primary:
                          "text-[#353535] !text-lg !leading-8 !font-medium whitespace-nowrap",
                      }}
                      className="!m-0"
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>
        </Drawer>
      )}

      <div
        className={`flex items-center lg:pl-[34px] pl-4 pr-4 lg:py-5 py-2 rounded-full border border-[#FFFFFF33] backdrop-blur-[160px] bg-[#FFFFFF14]`}
      >
        <img
          src={LogoStar}
          alt="logo-image"
          onClick={() => navigate("/")}
          className="sm:hidden flex"
        />
        <span className="sm:flex hidden 2xl:min-w-[175px] min-w-fit 2xl:w-[175px] w-fit font-bold sm:text-2xl text-xl text-white md:leading-8 leading-6">
          incognetoLabs
        </span>
        <div
          className={`w-full flex lg:flex-row-reverse justify-end items-center lg:gap-0 gap-3 relative lg:border-l border-l-0 lg:pl-3 pl-0 lg:ml-[10px] ml-0 border-l-white`}
        >
          <button
            className="lg:hidden flex p-2 bg-transparent border border-[#ffffff1a] rounded"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            <img src={HamburgerIcon} alt="menu" />
          </button>
          <ul className="lg:flex hidden items-center gap-6">
            {navItem.map((item) => {
              return (
                <li
                  key={item.id}
                  className={`text-base font-normal leading-6 cursor-pointer ${
                    item.path === currentPath ? "text-[#F81515]" : "text-white"
                  }`}
                  onClick={() => item.path && navigate(item.path)}
                >
                  {item.menuItem}
                </li>
              );
            })}
          </ul>
          <button
            type="button"
            className="px-5 py-3 flex items-center gap-2 lg:absolute static top-1/2 right-0 lg:-translate-y-1/2 translate-y-0 text-base font-bold text-white leading-6 bg-[#B30707] border border-[#F81515] rounded-full whitespace-nowrap"
            onClick={() => setEBookOpen(true)}
          >
            <img
              src={DownloadIcon}
              alt="downloadIconImage"
              width={24}
              height={24}
            />
            Get eBook
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
